// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare let __webpack_nonce__: string | undefined;

/**
 * Reads the CSP nonce from the <meta property="csp-nonce"> tag injected by the
 * server and sets webpack's internal nonce variable so that dynamically injected
 * script/style tags (e.g. from styled-components) include the nonce attribute.
 *
 * Must be called once at app startup, before any component renders.
 */
export function initCspNonce(): void {
  if (typeof document !== "undefined") {
    const cspNonce = document
      .querySelector('meta[property="csp-nonce"]')
      ?.getAttribute("content");
    if (cspNonce) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      __webpack_nonce__ = cspNonce;
    }
  }
}
